export default __webpack_public_path__ + "static/media/img_about03-m.0fe6c5fc.png";